import { render, staticRenderFns } from "./documentFile.vue?vue&type=template&id=ec760404"
import script from "./documentFile.vue?vue&type=script&lang=js"
export * from "./documentFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports